"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _moment = _interopRequireDefault(require("moment"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _lang = _interopRequireDefault(require("@/lang"));

var _validate = require("@/utils/validate");

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

var _SummaryPopup = _interopRequireDefault(require("@/components/SummaryPopup"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "agentRemitOrder:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default,
    SummaryPopup: _SummaryPopup.default
  },
  directives: {
    waves: _waves.default
  },
  watch: {
    'withdrawTemp.processRemitAmount': function withdrawTempProcessRemitAmount(newVal, oldVal) {
      if (!(0, _validate.isMoney)(newVal, false, this.numberOfDecimal)) {
        this.withdrawTemp.processRemitAmount = oldVal;
      } else if (newVal != null) {
        var param = Math.pow(10, this.numberOfDecimal);
        this.withdrawTemp.processRemitAmountAfterConversion = Math.round(this.withdrawTemp.processRemitAmount * this.rate * param) / param;
      }
    },
    'listQuery.remitType': function listQueryRemitType(newVal, oldVal) {
      if (newVal !== "BANK") {
        this.listQuery.code = "";
      }
    },
    'withdrawTemp.currencyTo': function withdrawTempCurrencyTo(newVal, oldVal) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.currencyExchangeRateOption[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.key == newVal) {
            this.rate = parseFloat(item.displayName).toFixed(2);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var param = Math.pow(10, this.numberOfDecimal);
      this.withdrawTemp.processRemitAmountAfterConversion = Math.round(this.withdrawTemp.processRemitAmount * this.rate * param) / param;
    },
    'withdrawTemp.processRemitAmountAfterConversion': function withdrawTempProcessRemitAmountAfterConversion(newVal, oldVal) {
      if (!(0, _validate.isMoney)(newVal, false, this.numberOfDecimal)) {
        this.withdrawTemp.processRemitAmountAfterConversion = oldVal;
      } else if (newVal != null) {
        var param = Math.pow(10, this.numberOfDecimal);
        this.withdrawTemp.processRemitAmount = Math.round(this.withdrawTemp.processRemitAmountAfterConversion / this.rate * param) / param;
      }
    }
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['bankOption', 'bankAndAreaOption', 'remitType', 'approvalStatusOption', 'remitAreaType', 'remitTypeEnums'])),
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      time: null,
      agentOption: null,
      // bankOption: null,
      dialogFormVisible: false,
      dialogWithdrawVisible: false,
      dialogWithdrawVisibleForAccount: false,
      approveType: "",
      formLoading: false,
      showRequiredMessage: false,
      availableAmount: 0,
      isDisabled: false,
      remitTypeForm: 'BANK',
      numberOfDecimal: 2,
      rate: 1.00,
      currencyExchangeRateOption: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        agentId: "",
        orderNo: "",
        code: "",
        remitType: "",
        accountNo: "",
        RemitAmount: "",
        status: "",
        timeList: [new Date(Date.now()), new Date(Date.now())],
        createStartTime: "",
        createEndTime: ""
      },
      formTemp: {
        id: null,
        remitType: null,
        code: null,
        bankBranch: null,
        accountName: null,
        processRemitAmount: null,
        processRemitAmountAfterConversion: null,
        currencyTo: null,
        remitPictureFile: null,
        rejectReason: null,
        rate: null
      },
      remitTypeEnums: {
        alipay: 'ALIPAY',
        bank: 'BANK',
        weChat: 'WECHAT'
      },
      withdrawTemp: {},
      withdrawTempLabelAndOption: {
        codeOption: [],
        codeNameLabel: _lang.default.t('SMS.bankCode'),
        accountNameLabel: _lang.default.t('agentRemitOrder.accountName'),
        accountNoLabel: _lang.default.t('agentRemitOrder.accountNo')
      },
      accountDetail: {
        remitType: null,
        remitTypeForm: null,
        code: null,
        bankBranch: null,
        accountName: null,
        accountNo: null
      },
      uploadRule: {
        required: true,
        message: _lang.default.t("SMS.bankCode") + _lang.default.t("SMS.canNotBeEmpty"),
        trigger: "blur"
      },
      remitForm: {
        code: _lang.default.t('SMS.bankCode'),
        accountNo: _lang.default.t('SMS.bankAccountNo'),
        accountName: _lang.default.t('SMS.bankAccountName')
      },
      withdrawRules: {
        code: [{
          required: true,
          message: _lang.default.t("SMS.bankCode") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        // bankBranch: [
        //   {
        //     required: true,
        //     message:
        //       i18n.t("SMS.bankBranch") + i18n.t("SMS.canNotBeEmpty"),
        //     trigger: "blur",
        //   },
        // ],
        accountName: [{
          required: true,
          message: _lang.default.t("SMS.bankAccountName") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        currencyTo: [{
          required: true,
          message: _lang.default.t("common.currencyType") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        accountNo: [{
          required: true,
          message: _lang.default.t("SMS.bankAccountNo") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        processRemitAmount: [{
          required: true,
          message: _lang.default.t("SMS.remitAmount") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }]
      },
      viewSummary: false,
      summaryList: [],
      uploadUrl: process.env.VUE_APP_BASE_API + "/agentRemitOrder/auditSuccess"
    };
  },
  created: function created() {
    var _this = this;

    this.getNumberOfDecimal();
    this.getOption();
    this.getFilePath();
    this.setDefaultTime();
    this.$nextTick(function (_) {
      _this.getList();
    });
  },
  methods: {
    getNumberOfDecimal: function getNumberOfDecimal() {
      var _this2 = this;

      _httpUtils.default.post("agentCost", "getNumberOfDecimal", {}, null).then(function (res) {
        _this2.numberOfDecimal = res.data.numberOfDecimal;
      }).catch(function (err) {
        _this2.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    changeRemitType: function changeRemitType(remitType) {
      this.remitTypeForm = remitType;
      this.withdrawTemp.code = null;

      if (remitType == this.remitTypeEnums.bank) {
        this.withdrawTemp.remitType = this.remitTypeEnums.bank;
        this.withdrawTempLabelAndOption = {
          codeOption: this.bankOption,
          codeNameLabel: _lang.default.t('SMS.bankCode'),
          accountNameLabel: _lang.default.t('SMS.bankAccountName'),
          accountNoLabel: _lang.default.t('SMS.bankAccountNo')
        };
      }

      if (remitType == this.remitTypeEnums.weChat) {
        this.withdrawTemp.remitType = this.remitTypeEnums.weChat;
        this.withdrawTemp.bankBranch = null;
        this.withdrawTempLabelAndOption = {
          codeOption: this.remitAreaType,
          codeNameLabel: _lang.default.t('agentRemitOrder.weChat') + _lang.default.t('message.regionText'),
          accountNameLabel: _lang.default.t('agentRemitOrder.accountName'),
          accountNoLabel: _lang.default.t('agentRemitOrder.accountNo')
        };
      }

      if (remitType == this.remitTypeEnums.alipay) {
        this.withdrawTemp.remitType = this.remitTypeEnums.alipay;
        this.withdrawTemp.bankBranch = null;
        this.withdrawTempLabelAndOption = {
          codeOption: this.remitAreaType,
          codeNameLabel: _lang.default.t('agentRemitOrder.alipay') + _lang.default.t('message.regionText'),
          accountNameLabel: _lang.default.t('agentRemitOrder.accountName'),
          accountNoLabel: _lang.default.t('agentRemitOrder.accountNo')
        };
      }
    },
    getFilePath: function getFilePath() {
      var _this3 = this;

      _httpUtils.default.get("agentSystemConfig", "getFilePath").then(function (res) {
        _this3.fileServerPath = res;
      });
    },
    concatFilePath: function concatFilePath(path) {
      var fullPath = "";

      if (this.fileServerPath === null) {
        return;
      } else {
        fullPath = this.fileServerPath + path;
        return fullPath;
      }
    },
    setDefaultTime: function setDefaultTime() {
      var a = new Date(Date.now());
      a.setHours(0, 0, 0, 0);
      var b = new Date(Date.now());
      b.setHours(23, 59, 59, 0);
      this.listQuery.timeList = [this.dateFormat(a), this.dateFormat(b)];
    },
    convertAgentName: function convertAgentName(name) {
      var found = "";

      if (this.agentOption === null) {
        return;
      }

      this.agentOption.forEach(function (status) {
        if (status.agentId == name) {
          found = status.agentName;
          return;
        }
      });
      return found;
    },
    convertApprovalStatusName: function convertApprovalStatusName(name) {
      var found = "";
      this.approvalStatusOption.forEach(function (status) {
        if (parseInt(status.key) == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertRemitTypeToName: function convertRemitTypeToName(code) {
      var found = code;
      this.remitType.forEach(function (status) {
        if (status.key == code) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertBankTypeName: function convertBankTypeName(name) {
      var found = "";
      this.bankOption.forEach(function (status) {
        if (status.key == name) {
          found = '/' + status.display_name;
          return;
        }
      });
      this.remitAreaType.forEach(function (status) {
        if (status.key == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined) {
        return "";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    getOption: function getOption() {
      var _this4 = this;

      _httpUtils.default.post("agent", "getAgents", null, null).then(function (agent) {
        _this4.agentOption = agent.data;
      }).catch(function (err) {
        _this4.$message({
          message: err.message,
          type: 'error'
        });
      });

      _httpUtils.default.post("currencyExchangeRate", "getCurrencyExchangeRateForUSD", null, null).then(function (res) {
        var option = res.data.USD;

        for (var key in option) {
          _this4.currencyExchangeRateOption.push({
            key: key,
            displayName: option[key]
          });
        }
      }).catch(function (err) {
        _this4.$message({
          message: err.message,
          type: 'error'
        });
      }); // httpUtils.post("agentRemitOrder", "getBanks", null, null).then((res) => {
      //   this.bankOption = res.data;
      // }).catch(err=>{
      //   this.$notify({
      //     title: this.$t("common.error"),
      //     message: this.$t("common.fetchError")+','+err.message,
      //     type: "error"
      //   });});;

    },
    getList: function getList() {
      var _this5 = this;

      if (!this.hasViewPermission) {
        return;
      }

      ;
      this.listLoading = true;
      this.listQuery.createStartTime = this.listQuery.timeList[0];
      this.listQuery.createEndTime = this.listQuery.timeList[1];

      _httpUtils.default.post("agentRemitOrder", "list", null, this.listQuery).then(function (res) {
        _this5.viewSummary = false;
        _this5.summaryList = [];
        _this5.list = res.data.rows;
        _this5.total = res.data.total;
        setTimeout(function () {
          _this5.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this5.$message({
          type: "error",
          message: err.message
        });
      });
    },
    getStatistic: function getStatistic() {
      var _this6 = this;

      var params = this.getQueryParams();

      _httpUtils.default.post("agentRemitOrder", "sum", null, params).then(function (res) {
        var data = res.data;
        _this6.summaryList = [[{
          label: 'SMS.availableProfitBefore',
          value: data.processAvailableAmountBefore || 0,
          unit: 'USD'
        }, {
          label: 'SMS.withdrawalAmount',
          value: data.processRemitAmount || 0,
          unit: 'USD'
        }, {
          label: 'SMS.availableProfit',
          value: data.processAvailableAmount || 0,
          unit: 'USD'
        }, {
          label: 'SMS.frozenAmount',
          value: data.processFrozenAmount || 0,
          unit: 'USD'
        }], [{
          label: 'common.CNY',
          value: data.processRemitAmountAfterConversionCNY || 0,
          unit: 'CNY'
        }, {
          label: 'common.HKD',
          value: data.processRemitAmountAfterConversionHKD || 0,
          unit: 'HKD'
        }, {
          label: 'common.USD',
          value: data.processRemitAmountAfterConversionUSD || 0,
          unit: 'USD'
        }], [{
          label: 'option.pending',
          value: data.status1 || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'option.examinationPassed',
          value: data.status2 || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'option.auditNotPassed',
          value: data.status4 || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'option.manualReview',
          value: data.status8 || 0,
          unit: 'SMS.tiao'
        }]];
      }).catch(function (err) {
        _this6.$notify({
          title: _this6.$t("common.error"),
          message: _this6.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      }).finally(function () {
        if (_this6.viewSummary == true) {
          _this6.viewSummary = false;
        } else {
          _this6.viewSummary = true;
        }
      });
    },
    resetFormTemp: function resetFormTemp() {
      this.formTemp = {
        id: null,
        code: null,
        bankBranch: null,
        accountName: null,
        processRemitAmount: null,
        processRemitAmountAfterConversion: null,
        rate: 1.00,
        currencyTo: "USD",
        remitPictureFile: null,
        rejectReason: null
      };
      this.approveType = "";
    },
    resetWithdrawTemp: function resetWithdrawTemp() {
      var _this7 = this;

      this.withdrawTemp = {
        remitType: "",
        code: "",
        bankBranch: "",
        accountName: "",
        accountNo: "",
        processRemitAmount: "",
        processRemitAmountAfterConversion: "",
        rate: 1.00,
        currencyTo: "USD"
      };
      this.$nextTick(function () {
        return _this7.$refs["dataWithdraw"].clearValidate();
      });
    },
    getRowData: function getRowData(row) {
      this.formTemp = {
        id: row.id,
        remitType: this.convertRemitTypeToName(row.remitType),
        code: row.code,
        bankBranch: row.bankBranch,
        accountName: row.accountName,
        accountNo: row.accountNo,
        processRemitAmount: row.processRemitAmount,
        processRemitAmountAfterConversion: row.processRemitAmountAfterConversion,
        currencyTo: row.currencyTo,
        rate: 1.00,
        rejectReason: "",
        remitPictureFile: ""
      };
    },
    getRowDataForWithdraw: function getRowDataForWithdraw() {
      var _this8 = this;

      _httpUtils.default.post("agentRemitOrder", "getAvailableAmount", null, null).then(function (res) {
        _this8.availableAmount = res.data.availableAmount;
      }).catch(function (err) {
        _this8.$notify({
          type: "error",
          message: err.message
        });
      });
    },
    getQueryParams: function getQueryParams() {
      var createStartTime, createEndTime, status;

      if (!this.listQuery.timeList) {
        createStartTime = getYesterday();
        createEndTime = getYesterdayEnd();
      } else {
        createStartTime = this.listQuery.timeList[0];
        createEndTime = this.listQuery.timeList[1];
      }

      if (this.listQuery.status !== null) {
        status = this.listQuery.status;
      }

      return {
        pageNum: this.listQuery.pageNum,
        pageSize: this.listQuery.pageSize,
        createStartTime: createStartTime,
        createEndTime: createEndTime,
        agentId: this.listQuery.agentId,
        orderNo: this.listQuery.orderNo,
        remitType: this.listQuery.remitType,
        code: this.listQuery.code,
        accountNo: this.listQuery.accountNo,
        status: status
      };
    },
    handleExportReport: function handleExportReport() {
      var excelName = _lang.default.t("route.agentRemitOrderReport") + ".xlsx";
      var params = this.getQueryParams(); // httpUtils.getByBlob("statisticalChannel", "excel", params, excelName);

      _httpUtils.default.getByBlob("agentRemitOrder", "excel", params, excelName); // MessageBox.confirm(
      //   i18n.t("warningMessage.pleaseWaitForExportAndNavigateMessage"),
      //   i18n.t("warningMessage.pleaseWaitForExportAndNavigateTitle"),
      //   {
      //     confirmButtonText: i18n.t("warningMessage.exportAndNavigateConfirmButtonText"),
      //     cancelButtonText: i18n.t("warningMessage.exportAndNavigateCancelButtonText"),
      //     type: 'warning'
      //   }
      // ).then(() => {
      //   // route to exported excel page
      //   this.$router.push({
      //     name: "exportedExcel:view"
      //   });
      // }).catch(() => null);

    },
    upload: function upload() {
      if (this.approveType === "success") {
        this.uploadSuccess();
      } else {
        this.uploadFail();
      }
    },
    uploadSuccess: function uploadSuccess() {
      var _this9 = this;

      if (this.$refs.upload.uploadFiles.length == 0) {
        this.showRequiredMessage = true;
        return;
      }

      this.showRequiredMessage = false;
      var file = this.$refs.upload.uploadFiles[0].raw;
      var formData = new FormData();
      formData.append("file", file);
      formData.append("postInfo", new Blob([JSON.stringify({
        id: this.formTemp.id
      })], {
        type: "application/json"
      }));
      var actionUrl = "";

      if (this.approveType === "success") {
        actionUrl = "auditSuccess";
      } else {
        return;
      }

      _httpUtils.default.post("agentRemitOrder", actionUrl, null, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(function (d) {
        if (d.code === 200) {
          _this9.$message({
            message: _lang.default.t("message.message50"),
            type: "success"
          });
        } else if (d.code === 401) {
          _this9.$message({
            message: _lang.default.t("message.message55"),
            type: "error"
          });
        } else if (d.code === 403) {
          _this9.$message({
            message: _lang.default.t("message.message56"),
            type: "error"
          });
        }

        _this9.dialogFormVisible = false;

        _this9.resetFormTemp();

        _this9.getList();
      }).catch(function (err) {
        _this9.$message({
          type: "error",
          message: err.message
        });
      });
    },
    uploadFail: function uploadFail() {
      var _this10 = this;

      this.formTemp.remitPictureFile = null;

      _httpUtils.default.post("agentRemitOrder", "auditFail", null, this.formTemp).then(function (d) {
        if (d.code === 200) {
          _this10.$message({
            message: _lang.default.t("message.message52"),
            type: "success"
          });
        } else if (d.code === 401) {
          _this10.$message({
            message: _lang.default.t("message.message55"),
            type: "error"
          });
        } else if (d.code === 403) {
          _this10.$message({
            message: _lang.default.t("message.message56"),
            type: "error"
          });
        }

        _this10.dialogFormVisible = false;

        _this10.resetFormTemp();

        _this10.getList();
      }).catch(function (err) {
        _this10.$message({
          type: "error",
          message: err.message
        });
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.pageNum = 1;
      this.getList();
    },
    handleApproveSuccess: function handleApproveSuccess(state) {
      if (this.checkSelection()) {
        return;
      }

      this.resetFormTemp();
      this.getRowData(this.multipleSelection[0]);
      this.dialogFormVisible = true;
      this.approveType = "success";
    },
    handleWithdraw: function handleWithdraw(row) {
      this.changeRemitType(this.remitTypeEnums.bank);
      this.resetWithdrawTemp();
      this.getRowDataForWithdraw(row);
      this.dialogWithdrawVisible = true;
    },
    handleApproveFail: function handleApproveFail(state) {
      if (this.checkSelection()) {
        return;
      }

      this.resetFormTemp();
      this.getRowData(this.multipleSelection[0]);
      this.dialogFormVisible = true;
      this.approveType = "fail";
    },
    doApproveFailData: function doApproveFailData() {
      var _this11 = this;

      _httpUtils.default.post("agentRemitOrder", "auditFail", null, this.multipleSelection[0].id).then(function (res) {
        if (res.code === 200) {
          _this11.$notify({
            title: _lang.default.t("SMS.success"),
            message: _lang.default.t("message.message52"),
            type: "success",
            duration: 2000
          });

          _this11.resetFormTemp();

          _this11.getList();
        } else {
          _this11.$message({
            showClose: true,
            message: _lang.default.t("message.message53"),
            type: "warning"
          });
        }
      }).catch(function (err) {
        _this11.$message({
          type: "error",
          message: err.message
        });
      });
    },
    doWithdrawData: function doWithdrawData() {
      var _this12 = this;

      this.withdrawTemp.remitType = this.remitTypeForm;
      this.withdrawTemp.rate = this.rate;
      this.isDisabled = true;
      this.$refs["dataWithdraw"].validate(function (valid) {
        if (valid) {
          _httpUtils.default.post("agentRemitOrder", "add", null, _this12.withdrawTemp).then(function (res) {
            if (res.code === 200) {
              _this12.$notify({
                title: _lang.default.t("message.message68"),
                type: "success",
                duration: 2000
              });

              _this12.dialogWithdrawVisible = false;
              setTimeout(function () {
                _this12.resetFormTemp();

                _this12.resetWithdrawTemp();

                _this12.getList();
              }, 1 * 1000);
            }
          }).catch(function (err) {
            _this12.$message({
              showClose: true,
              message: err.message,
              type: "warning"
            });
          }).finally(function () {
            setTimeout(function () {
              _this12.isDisabled = false;
            }, 1 * 1000);
          });
        } else {
          _this12.isDisabled = false;
        }
      });
    },
    checkSelection: function checkSelection() {
      var message, info;

      if (this.multipleSelection === undefined ? true : this.multipleSelection.length === 0) {
        message = _lang.default.t("message.message16");
        info = _lang.default.t("SMS.alarm");
        this.$message(message, info, {
          confirmButtonText: _lang.default.t("permission.confirm"),
          type: "warning"
        });
        return true;
      }
    },
    //Handle add check boxes for table
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    showAccountDetail: function showAccountDetail(row) {
      this.resetAccountDetail();
      this.setAccountDetail(row);
      this.changeRemitType(row.remitType);
      this.dialogWithdrawVisibleForAccount = true;
    },
    resetAccountDetail: function resetAccountDetail() {
      this.accountDetail = {
        remitType: null,
        remitTypeForm: null,
        code: null,
        bankBranch: null,
        accountName: null,
        accountNo: null
      };
    },
    setAccountDetail: function setAccountDetail(row) {
      this.accountDetail = {
        remitType: this.convertRemitTypeToName(row.remitType) + this.convertBankTypeName(row.code),
        remitTypeForm: row.remitType,
        code: row.code,
        bankBranch: row.bankBranch,
        accountName: row.accountName,
        accountNo: row.accountNo
      };
    }
  }
};
exports.default = _default;